module.exports = __webpack_public_path__ + "static/media/5_reply.f12e0125.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact/5_reply.svg
// module id = 2173
// module chunks = 0